/* eslint-disable react-hooks/exhaustive-deps */

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Icon, TextField, IconButton, Card, Modal } from "@mui/material";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import InputMask from "react-input-mask";
import { useAuthContext } from "context/AuthContext";

import moment from "moment";
import axios from "axios";
import { URL_API } from "config";
import { useDashboardCardContext } from "context/DashboardCardContext";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function Analytics() {
  const [aprovated, setAprovated] = useState();
  const [aprovatedPercentage, setAprovatedPercentage] = useState();
  const [reprovated, setReprovated] = useState();
  const [reprovatedPercentage, setReprovatedPercentage] = useState();
  const [averageTime, setAverageTime] = useState();
  const [aprovatedTime, setAprovatedTime] = useState();
  const [aprovatedTimePercentage, setAprovatedTimePercentage] = useState();
  const [waitingSignatureTime, setWaitingSignatureTime] = useState(0);
  const [chartData, setChartData] = useState();
  const [chartDataLine, setChartDataLine] = useState();
  const [chartDataLineYear, setChartDataLineYear] = useState();
  const [chartDataOptions, setChartOptions] = useState();
  const [chartDataLineOptions, setChartDataLineOptions] = useState();
  const [chartDataRankPAs, setChartDataRankPAs] = useState();
  const [chartDataRankPAsOptions, setChartDataRankPAsOptions] = useState();
  const [label, setLabel] = useState("Desde o início do mês");
  const [dateFrom, setDateFrom] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));

  const [chartExample1Data] = React.useState("data1");

  const [isMounted, setIsMounted] = useState(true);

  const navigate = useNavigate();

  const { user, openAlert, handleAlert } = useAuthContext();

  const {
    setDateCardAprovatedFrom,
    setDateCardAprovatedTo,
    setDateCardReprovatedFrom,
    setDateCardReprovatedTo,
    setDateCardWaitingSignatureFrom,
    setDateCardWaitingSignatureTo,
    setDateCardAverageAproveFrom,
    setDateCardAverageAproveTo,
    setDateCardStatusAverageTimeFrom,
    setDateCardStatusAverageTimeTo,
  } = useDashboardCardContext();

  const tag = localStorage.getItem("Tag");

  const getDashboard = async (usr) => {
    try {
      if (isMounted) {
        Promise.all([
          usr?.profile === 99 && (await getAprovatedsTime()),
          usr?.profile === 99 && (await getAverageTime()),
          usr?.profile === 99 && (await getWaitingSignatureTime()),
          usr?.profile === 99 && (await getRankPAs()),
          await getReprovateds(usr),
          await getAprovateds(usr),
          await getChartData(usr),
          await getChartDataLine(usr),
          await getChartDataLineYear(usr),
        ]);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Tag");
        navigate("/auth/login");
      } else {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    (async () => {
      user && (await getDashboard(user));
    })();
    return () => {
      setIsMounted(false);
    };
  }, [user]);

  // CARDS
  async function getAprovateds(content) {
    await axios
      .get(
        URL_API +
          `/dash/aprove?dateFrom=${dateFrom}&dateTo=${dateTo}` +
          `${content?.company_id ? `&company_id=${content?.company_id}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setAprovated(response.data?.count);
        setAprovatedPercentage(response.data?.percentage);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getAprovatedsTime() {
    await axios
      .get(
        URL_API + `/dash/average-aprove?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setAprovatedTime(response.data?.count);
        setAprovatedTimePercentage(response.data?.percentage);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getAverageTime() {
    await axios
      .get(
        URL_API +
          `/status-times/average-time?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setAverageTime(response.data?.hours);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");

          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getReprovateds(content) {
    await axios
      .get(
        URL_API +
          `/dash/reprove?dateFrom=${dateFrom}&dateTo=${dateTo}` +
          `${content?.company_id ? `&company_id=${content?.company_id}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setReprovated(response.data?.count);
        setReprovatedPercentage(response.data?.percentage);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getWaitingSignatureTime() {
    await axios
      .get(
        URL_API +
          `/dash/waiting-signature?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setWaitingSignatureTime(response.data?.count);
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  // GRAPHS
  async function getChartData(content) {
    await axios
      .get(
        URL_API +
          `/dash/percentage-status?dateFrom=${dateFrom}&dateTo=${dateTo}` +
          `${
            content?.profile !== 99 && content?.company_id
              ? `&company_id=${content?.company_id}`
              : ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setChartData({
          datasets: response.data.dataChart.datasets,
          labels: response.data.dataChart.labels,
        });
        setChartOptions({
          options: response.data.options,
        });
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getChartDataLine(content) {
    await axios
      .get(
        URL_API +
          `/dash/get-growth?dateFrom=${dateFrom}&dateTo=${dateTo}` +
          `${
            content?.profile !== 99 && content?.company_id
              ? `&company_id=${content?.company_id}`
              : ""
          }`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setChartDataLine({
          datasets: response.data.dataChart.datasets,
          labels: response.data.dataChart.labels,
        });
        setChartDataLineOptions({
          options: response.data.options,
        });
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getChartDataLineYear(content) {
    await axios
      .get(
        URL_API +
          `/dash/get-growth-year?dateFrom=${dateFrom}&dateTo=${dateTo}` +
          `${content?.company_id ? `&company_id=${content?.company_id}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        setChartDataLineYear({
          datasets: response.data.dataChart.datasets,
          labels: response.data.dataChart.labels,
        });
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  async function getRankPAs() {
    await axios
      .get(URL_API + `/dash/rank-pas?dateFrom=${dateFrom}&dateTo=${dateTo}`, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(function (response) {
        setChartDataRankPAs({
          datasets: response.data.dataChart.datasets,
          labels: response.data.dataChart.labels,
        });
        setChartDataRankPAsOptions({
          options: response.data.options,
        });
      })
      .catch(function (error) {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Card>
          <MDBox pt={2}>
            <MDBox
              p={1}
              lineHeight={1}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid container>
                <Grid item>
                  <InputMask
                    aria-describedby="inputGroup-sizing-lg"
                    aria-label="Sizing example input"
                    type="text"
                    mask="99/99/9999"
                    name="dateFrom"
                    defaultValue={moment(dateFrom).format("DD/MM/YYYY")}
                    onChange={(event) => {
                      if (event.target.value.indexOf("_") === -1) {
                        setDateFrom(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardAprovatedFrom(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardReprovatedFrom(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardWaitingSignatureFrom(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardAverageAproveFrom(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardStatusAverageTimeFrom(
                          event.target.value.split("/").reverse().join("-")
                        );
                      }
                    }}
                  >
                    {() => <TextField label="Buscar por data inicial..." />}
                  </InputMask>
                </Grid>
                <MDBox p={1} pt={6} />
                <Grid item>
                  <InputMask
                    aria-describedby="inputGroup-sizing-lg"
                    aria-label="Sizing example input"
                    type="text"
                    mask="99/99/9999"
                    name="dateTo"
                    defaultValue={moment(dateTo).format("DD/MM/YYYY")}
                    onChange={(event) => {
                      if (event.target.value.indexOf("_") === -1) {
                        setDateTo(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardAprovatedTo(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardReprovatedTo(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardWaitingSignatureTo(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardAverageAproveTo(
                          event.target.value.split("/").reverse().join("-")
                        );
                        setDateCardStatusAverageTimeTo(
                          event.target.value.split("/").reverse().join("-")
                        );
                      }
                    }}
                  >
                    {() => <TextField label="Buscar por data final..." />}
                  </InputMask>
                </Grid>
                <MDBox p={1} pt={6} />
                <Grid item>
                  <IconButton
                    onClick={async () => {
                      Promise.all([
                        user?.profile === 99 && (await getAprovatedsTime()),
                        user?.profile === 99 && (await getAverageTime()),
                        user?.profile === 99 &&
                          (await getWaitingSignatureTime()),
                        user?.profile === 99 && (await getRankPAs()),
                        await getReprovateds(user),
                        await getAprovateds(user),
                        await getChartData(user),
                        await getChartDataLine(user),
                        await getChartDataLineYear(user),
                      ]);

                      setLabel(
                        `Desde ${moment(dateFrom).format("DD/MM/YYYY")}`
                      );
                    }}
                    sx={{
                      color: "#fff",
                      background: "#3f50b5",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "blue",
                      },
                    }}
                  >
                    <Icon>search</Icon>
                  </IconButton>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>
      <MDBox py={3}>
        <MDBox mt={1.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox
                mb={1.5}
                onClick={() => navigate("/admin/aprovados")}
                sx={{ cursor: "pointer" }}
              >
                <ComplexStatisticsCard
                  color="success"
                  icon="checkCircleOutline"
                  title="N° ADMISSÕES APROVADAS"
                  count={aprovated ? aprovated : "0"}
                  percentage={{
                    color: "success",
                    amount: `${
                      aprovatedPercentage ? aprovatedPercentage : "0"
                    }%`,
                    label: label,
                  }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox
                mb={1.5}
                onClick={() => navigate("/admin/reprovados")}
                sx={{ cursor: "pointer" }}
              >
                <ComplexStatisticsCard
                  color="error"
                  icon="close"
                  title="N° ADMISSÕES REPROVADAS"
                  count={reprovated ? reprovated : "0"}
                  percentage={{
                    color: "success",
                    amount: `${
                      reprovatedPercentage ? reprovatedPercentage : "0"
                    }%`,
                    label: label,
                  }}
                />
              </MDBox>
            </Grid>
            {user?.profile === 99 && (
              <>
                <Grid item xs={12} md={6} lg={3}>
                  <MDBox
                    mb={1.5}
                    onClick={() => navigate("/admin/tempo-medio-aprovacao")}
                    sx={{ cursor: "pointer" }}
                  >
                    <ComplexStatisticsCard
                      color="success"
                      icon="timer"
                      title="TEMPO MÉDIO APROVAÇÃO"
                      count={`${aprovatedTime ? aprovatedTime : "0"} Dias`}
                      percentage={{
                        color: "success",
                        amount: `${
                          aprovatedTimePercentage
                            ? aprovatedTimePercentage
                            : "0"
                        }%`,
                        label: label,
                      }}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <MDBox
                    mb={1.5}
                    onClick={() => navigate("/admin/aguardando-assinatura")}
                    sx={{ cursor: "pointer" }}
                  >
                    <ComplexStatisticsCard
                      color="info"
                      icon="timer"
                      title="AGUARDANDO ASSINATURA"
                      count={
                        waitingSignatureTime !== 1
                          ? `${waitingSignatureTime} Contas`
                          : `${waitingSignatureTime} Conta`
                      }
                      percentage={{
                        color: "success",
                        label: label,
                      }}
                    />
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <MDBox
                    mb={1.5}
                    onClick={() => navigate("/admin/tempo-medio-status")}
                    sx={{ cursor: "pointer" }}
                  >
                    <ComplexStatisticsCard
                      color="primary"
                      icon="timer"
                      title="TEMPO MÉDIO STATUS"
                      count={
                        averageTime
                          ? `${averageTime} ${
                              averageTime === 1 ? "hora" : "horas"
                            }`
                          : "0 horas"
                      }
                      percentage={{
                        color: "success",
                        label: label,
                      }}
                    />
                  </MDBox>
                </Grid>{" "}
              </>
            )}
          </Grid>
        </MDBox>
        <MDBox mt={6}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <DefaultLineChart
                  icon={{ color: "info", component: "leaderboard" }}
                  title="Visão Geral"
                  description="Crescimento"
                  chart={{
                    labels:
                      chartExample1Data === "data1"
                        ? chartDataLine?.labels
                        : chartDataLineYear?.labels,
                    datasets:
                      chartExample1Data === "data1"
                        ? chartDataLine?.datasets
                        : chartDataLineYear?.datasets,
                  }}
                  options={{ chartDataLineOptions }}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
              <MDBox mb={3}>
                <VerticalBarChart
                  icon={{ color: "warning", component: "percent" }}
                  title="STATUS"
                  description="Porcentagem de Cada Status"
                  chart={{
                    labels: chartData?.labels,
                    datasets: chartData?.datasets,
                  }}
                  options={{ chartDataOptions }}
                />
              </MDBox>
            </Grid>
            {user?.profile === 99 && (
              <Grid item xs={12} md={6} lg={12}>
                <MDBox mb={3}>
                  <VerticalBarChart
                    icon={{ color: "dark", component: "stars" }}
                    title="PA"
                    description="Ranking dos PAs"
                    chart={{
                      labels: chartDataRankPAs?.labels,
                      datasets: chartDataRankPAs?.datasets,
                    }}
                    options={{ chartDataRankPAsOptions }}
                  />
                </MDBox>
              </Grid>
            )}
          </Grid>
        </MDBox>
      </MDBox>
      <Modal
        open={openAlert}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          width: "40%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <MDBox
          sx={{
            background: "white",
            padding: "4rem",
            borderRadius: "30px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MDTypography sx={{ textAlign: "center", fontWeight: "bold" }}>
            Alerta
          </MDTypography>

          <MDTypography
            variant="body2"
            sx={{ textAlign: "justify", marginTop: 5 }}
          >
            Olá, obtivemos alteração nas normas regulatórias da cooperativa
            Viacredi, sobre o tema de abertura de contas.
          </MDTypography>

          <MDTypography
            variant="body2"
            sx={{ textAlign: "justify", marginTop: 1 }}
          >
            A partir do dia <strong>27/09/2024</strong> todas as contas de
            colaboradores que residirem fora da área de atuação da cooperativa
            (Onde não há posto de atendimento físico, para atendimento do
            cooperado), serão abertas obrigatoriamente na modalidade{" "}
            <strong>CONTA SALÁRIO.</strong>
          </MDTypography>

          <MDTypography
            variant="body2"
            sx={{ textAlign: "justify", marginTop: 1 }}
          >
            Em caso de dúvidas contate seu posto de atendimento.
          </MDTypography>

          <MDTypography variant="body2" sx={{ marginBottom: 3, marginTop: 1 }}>
            Agradecemos a compreensão e estamos á disposição nos telefones
            oficiais da cooperativa: (47) 3221- 5200 ou WhatsApp (47)
            99158-1853.
          </MDTypography>

          <MDTypography variant="body2" sx={{ marginBottom: 2 }}>
            Atenciosamente Viacredi.
          </MDTypography>

          <MDButton
            type="submit"
            variant="gradient"
            color="info"
            onClick={handleAlert}
          >
            Confirmar
          </MDButton>
        </MDBox>
      </Modal>
    </DashboardLayout>
  );
}

export default Analytics;
